import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import PopularComics from './components/PopularComics';
import FeaturesSection from './components/FeaturesSection';
import LatestUpdates from './components/LatestUpdates';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <PopularComics />
        <FeaturesSection />
        <LatestUpdates />
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          'name': '虫虫漫画网 - 下拉式完整版免费阅读',
          'description': '虫虫漫画网主打下拉式完整版免费阅读，无删减韩国漫画资源充足，下拉观看流畅不卡顿，免费为您呈现各类精彩韩国漫画的完整版剧情与画面。',
          'url': 'https://www.chongchongmanhua.com/',
          'breadcrumb': {
            '@type': 'BreadcrumbList',
            'itemListElement': [{
              '@type': 'ListItem',
              'position': 1,
              'name': '首页',
              'item': 'https://www.chongchongmanhua.com/'
            }]
          },
          'mainEntity': {
            '@type': 'ItemList',
            'itemListElement': [
              { '@type': 'ListItem', 'position': 1, 'name': '我独自升级', 'url': 'https://www.chongchongmanhua.com/comic/1' },
              { '@type': 'ListItem', 'position': 2, 'name': '女神降临', 'url': 'https://www.chongchongmanhua.com/comic/2' },
              { '@type': 'ListItem', 'position': 3, 'name': '全知读者视角', 'url': 'https://www.chongchongmanhua.com/comic/3' },
              { '@type': 'ListItem', 'position': 4, 'name': '某天成为公主', 'url': 'https://www.chongchongmanhua.com/comic/4' },
              { '@type': 'ListItem', 'position': 5, 'name': '剑尊归来', 'url': 'https://www.chongchongmanhua.com/comic/5' },
              { '@type': 'ListItem', 'position': 6, 'name': '诡秘之主', 'url': 'https://www.chongchongmanhua.com/comic/7' },
            ]
          }
        })
      }} />
    </>
  );
}